import React from "react";
import { useDrawer } from "../../../../common/hooks";
import BookContent from "./BookContent";
import "./content.css";

export default function ContentFooter(props) {
  const { color, title, content } = props;
  const { setContent } = useDrawer();

  return (
    <div>
      <svg
        style={{ padding: 0 }}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
      >
        <path
          fill={color}
          fill-opacity="1"
          d="M0,96L60,85.3C120,75,240,53,360,80C480,107,600,181,720,186.7C840,192,960,128,1080,106.7C1200,85,1320,107,1380,117.3L1440,128L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
        ></path>
      </svg>
      <div
        style={{
          backgroundColor: color,
        }}
        className="content-footer"
      >
        <h1>{content.length > 0 && title.toUpperCase()}</h1>
        <div className="section-content">
          {content.map((name) => (
            <div
              className="book-item"
              onClick={() => {
                setContent(<BookContent technology={name} />);
              }}
            >
              {name.toUpperCase()}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
